import { openComboItemWarningModal, showProgress } from "./DomFunctions";
import ChooseItem from "./ChooseItem/ChooseItem";
import FinalizeBill from "./Total/FinalizeBill";
import OrderHandler from "./OrderHandler";
import Mediator from "../../Utilities/Mediator";
import ChooseService from "./ChooseService/ChooseService";
import { ServiceType } from "../../Models/ServiceType";
import { createAnOrder, validateOrderAndCreatePayment, validateTagCodeAndCreateOrder } from "./OrderRequests.service";
import OrderValidator from "./OrderValidator";
import DibsCheckout from "../DibsCheckout/DibsCheckout";
import DibsPaymentResponse from "../../Models/Response/DibsPaymentResponse";

export default class CreateOrder {
	body: HTMLDivElement;
	backBtn: HTMLButtonElement;
	nextBtn: HTMLButtonElement;
	step: number;
	finalizeBillHandler: FinalizeBill;
	variantsCartDiv: HTMLDivElement;
	cartContainer: HTMLDivElement;
	chooseItemHandler: ChooseItem;
	stepsWrapper: HTMLDivElement;

	constructor() {
		this.body = document.querySelector('.create-order');
		this.backBtn = this.body.querySelector(':scope > div:nth-child(2) > div button');
		this.nextBtn = this.body.querySelector('div:nth-child(2) > div > div:nth-child(3) button');
		this.step = 1;
		this.stepsWrapper = this.body.querySelector("div");
		this.variantsCartDiv = document.querySelector('.create-order + div');
		this.cartContainer = document.querySelector(".cart-icon");
		OrderHandler.isDibsEnabled = this.body.dataset.isDibsEnabled.toLowerCase() === "true";

		this.init();
	}

	private init() {
		this.addEventsListeners();
		this.addNextButtonClickListener();
		this.addBackButtonClickListener();
		OrderHandler.updateCartIconCount();
		this.finalizeBillHandler = new FinalizeBill();
		this.gotoStep1();
	}

	private addEventsListeners() {
		Mediator.on("itemSelected", () => this.gotoStep2());
		Mediator.on("allItemsDeleted", () => this.changeNextButtonDisplay("none"));
		Mediator.on("serviceIsSelected", () => this.gotoStep3());
		Mediator.on("finalizeBillDispatched", () => this.gotoStep4());
		Mediator.on("serviceRemoved", () => this.changeNextButtonDisplay("none"));
		Mediator.on("orderStateChanged", () => this.toggleNextButtonAbility());
		Mediator.on("variantIsSelected", (backToStep2: boolean = false, backToStep1: boolean = false) => {
			if (backToStep2) {
				this.backToStep2();
			}
			if (backToStep1) {
				this.backToStep1();
			}

			this.changeNextButtonDisplay("inline-block");
		});
		Mediator.on("chooseItemDispatched", () => this.backToStep1());
		Mediator.on("orderCreationFailed", () => this.nextBtn.disabled = false);
		Mediator.on("orderPaymentCreated", (response: DibsPaymentResponse) => {
			this.finalizeBillHandler.removeFinalizeBill();
			this.nextBtn.style.display = "none";
			this.backBtn.style.display = "none";
			var checkout = new DibsCheckout(response.paymentId, response.checkoutKey);
			checkout.checkoutOrder()
				.then((paymentId: string) => {
					createAnOrder(paymentId, false);
					this.showConfirmationMessage();
				});
		});

		OrderHandler.cartIconContainer.onclick = () => {
			this.checkComboItemAndChangeStep(true);
		}
	}

	private showConfirmationMessage() {
		const dibsWrapper: HTMLDivElement = document.querySelector("#dibs-checkout-content");
		dibsWrapper.style.display = "none";

		const message = document.createElement('h3');
		message.innerText = dibsWrapper.dataset.confirmationMessage;
		message.classList.add('display-4', 'confirmation-message');

		this.stepsWrapper.appendChild(message);
	}

	private changeNextButtonDisplay(display: string) {
		this.nextBtn.style.display = display;
	}

	private checkComboItemAndChangeStep(isNext: boolean) {
		const currentItems = OrderHandler.currentItems.length;
		const completedItems = OrderHandler.completedSelectedItems.size;

		if (currentItems === 1 || completedItems === 0 || completedItems === currentItems) {
			if (isNext) {
				this.gotoStep4();
			} else {
				this.backToStep1()
			}
		} else { //combo item and not all items has services selected
			openComboItemWarningModal(isNext);
		}
	}

	private addNextButtonClickListener() {
		this.nextBtn.onclick = () => {
			switch (this.step) {
				case 1:
					this.gotoStep4();
					break;
				case 2:
				case 3:
					if (this.IsCanvasVariantsSelected) {
						Mediator.emit("canvasVariantSelected");
					} else {
						this.checkComboItemAndChangeStep(true);
					}
					break;
				case 4:
					this.createOrder();
					break;
				default:
					break;
			}
		}
	}

	private gotoStep1() {
		this.chooseItemHandler = new ChooseItem();
		this.nextBtn.style.display = "none";
		showProgress(1, true);
		this.step = 1;
		this.body.appendChild(this.cartContainer);
		this.cartContainer.style.display = "block";
		this.variantsCartDiv.style.display = "block";
	}

	private gotoStep2() {
		Mediator.emit("changeFastTrackStyle", "flex", "1", "auto");
		this.cartContainer.style.display = "block";
		this.backBtn.style.display = "inline-block";
		this.variantsCartDiv.style.display = "block";
		this.chooseItemHandler.removeChooseItem();
		new ChooseService();
		this.nextBtn.style.display = "none";
		showProgress(3, true);
		this.step = 2;
	}

	private gotoStep3() {
		Mediator.emit("changeFastTrackStyle", "flex", "1", "auto");
		this.cartContainer.style.display = "block";
		this.variantsCartDiv.style.display = "block";
		this.chooseItemHandler.removeChooseItem();
		Mediator.emit("serviceSelected");
		this.nextBtn.style.display = "none";
		showProgress(5, true);
		this.step = 3;
	}

	private gotoStep4() {
		if (OrderHandler.order.items.length > 0) {
			this.checkVariants();
			Mediator.emit("changeFastTrackStyle", "none", "0", "none");
			this.chooseItemHandler.removeChooseItem();
			this.variantsCartDiv.style.display = "none";
			this.cartContainer.style.display = "none";
			Mediator.emit("serviceSelected");
			Mediator.emit("variantSelected");
			this.backBtn.style.display = "inline-block";
			showProgress(7, true);
			this.nextBtn.style.display = "inline-block";
			this.nextBtn.innerHTML = this.nextBtn.dataset.submitorder;
			this.step = 4;
			this.toggleNextButtonAbility();
			this.finalizeBillHandler.fetchOrderTotal();
		}
	}

	private createOrder() {
		if (OrderValidator.isValidOrder) {
			this.nextBtn.disabled = true;
			if (OrderHandler.isDibsEnabled) {
				validateOrderAndCreatePayment();
			} else {
				validateTagCodeAndCreateOrder();
			}
		}
	}

	private get IsCanvasVariantsSelected(): boolean {
		const selectedServices = OrderHandler.selectedItem.services;
		const canvasServices = selectedServices.filter(s => s.type === ServiceType.Canvas);
		const IsCanvasServicesHasVariants = canvasServices.every(s => s.variants.length > 0);
		const hasImageSrc = canvasServices.every(c => c.imageSrc);

		return IsCanvasServicesHasVariants && canvasServices.length > 0 && !hasImageSrc;
	}


	private addBackButtonClickListener() {
		this.backBtn.onclick = () => {
			switch (this.step) {
				case 2:
					this.checkComboItemAndChangeStep(false);
					break;
				case 3:
				case 4:
					this.nextBtn.innerHTML = this.nextBtn.dataset.next;
					if (OrderHandler.isFastTrack) {
						this.backToStep1();
					} else {
						this.backToStep2();
					}
					this.toggleNextButtonAbility();
					break;
				default:
					break;
			}
		}
	}

	public backToStep1() {
		this.step = 1;
		showProgress(1, false);
		this.chooseItemHandler.fetchItemTiles();
		Mediator.emit("changeFastTrackStyle", "flex", "1", "auto");
		
		if (OrderHandler.order.items.length == 0) {
			this.nextBtn.style.display = "none";
		} else {
			this.nextBtn.style.display = "block";
		}

		this.backBtn.style.display = "none";
		this.variantsCartDiv.style.display = "block";
		this.cartContainer.style.display = "block";
		this.finalizeBillHandler.removeFinalizeBill();
		this.nextBtn.innerHTML = this.nextBtn.dataset.next;
		this.toggleNextButtonAbility();
		Mediator.emit("chooseItemDisplayed");
	}

	private backToStep2() {
		if (this.step == 3) {
			this.checkVariants();
		}
		this.step = 2;
		this.finalizeBillHandler.removeFinalizeBill();
		this.variantsCartDiv.style.display = "block";
		this.cartContainer.style.display = "block";
		Mediator.emit("changeFastTrackStyle", "flex", "1", "auto");
		Mediator.emit("variantSelected");
		this.nextBtn.style.display = "inline-block";
		new ChooseService();
		showProgress(3, false);
	}

	private checkVariants() {
		if (OrderHandler.selectedItem.services.length > 0
			&& OrderHandler.selectedItem.services.every(s => OrderValidator.isValidService(s))) {
			OrderHandler.addSelectedItemToShoppingCart();
		} else {
			OrderHandler.selectedItem.services.forEach(s => {
				if (!OrderValidator.isValidService(s)) {
					Mediator.emit("serviceCostChanged", s.id, -1);
					OrderHandler.removeService(OrderHandler.selectedItem.itemId, s.id);
					s.variants.forEach(v => Mediator.emit("variantRemoved", v.id));
				}
			});
		}
	}

	private toggleNextButtonAbility() {
		if (this.step == 4 && !OrderValidator.isValidOrder) {
			this.nextBtn.classList.add("disabled");
		} else {
			this.nextBtn.classList.remove("disabled");
		}
	}
}
